import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/services/detail/page'));
const CountriesPage = lazy(() => import('../pages/countries/page'));
const CountryDetailPage = lazy(() => import('../pages/countries/detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const KvkkPage = lazy(() => import('../pages/kvkk/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />,
  },
  {
    path: '/hizmetler/:slug',
    element: <ServiceDetailPage />,
  },
  {
    path: '/ulkeler',
    element: <CountriesPage />,
  },
  {
    path: '/ulkeler/:slug',
    element: <CountryDetailPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/sss',
    element: <FaqPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/cerez-politikasi',
    element: <CookiePolicyPage />,
  },
  {
    path: '/kvkk',
    element: <KvkkPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
